module.exports = __webpack_public_path__ + "img/business2.24d1af4e.jpg";